/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfiguredActionItemDto } from './configuredActionItemDto';


export interface InspectionEntryItemDto { 
    id: string;
    note: string;
    deadline?: InspectionEntryItemDto.DeadlineEnum;
    action?: ConfiguredActionItemDto;
    occurrenceProbability: InspectionEntryItemDto.OccurrenceProbabilityEnum;
    damageExtent: InspectionEntryItemDto.DamageExtentEnum;
    markedForPostProcessing: boolean;
    predefinedAssessmentId?: string;
    inspectionId: string;
    inspectionName: string;
    inspectionSendingTimestamp?: string;
    buildingId: string;
    checkpointId: string;
    checkpointName: string;
    buildingSectionId: string;
    sectionText: string;
    appliedFromPreviousInspection: boolean;
    repairTaskId?: string;
    repairTaskStatus?: InspectionEntryItemDto.RepairTaskStatusEnum;
    buildingEquipmentCount: number;
}
export namespace InspectionEntryItemDto {
    export type DeadlineEnum = 'YEAR' | 'HALF_YEAR' | 'ONE_MONTH' | 'NONE' | 'TEN_DAYS';
    export const DeadlineEnum = {
        Year: 'YEAR' as DeadlineEnum,
        HalfYear: 'HALF_YEAR' as DeadlineEnum,
        OneMonth: 'ONE_MONTH' as DeadlineEnum,
        None: 'NONE' as DeadlineEnum,
        TenDays: 'TEN_DAYS' as DeadlineEnum
    };
    export type OccurrenceProbabilityEnum = 'NO_FINDING' | 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH';
    export const OccurrenceProbabilityEnum = {
        NoFinding: 'NO_FINDING' as OccurrenceProbabilityEnum,
        VeryLow: 'VERY_LOW' as OccurrenceProbabilityEnum,
        Low: 'LOW' as OccurrenceProbabilityEnum,
        Medium: 'MEDIUM' as OccurrenceProbabilityEnum,
        High: 'HIGH' as OccurrenceProbabilityEnum
    };
    export type DamageExtentEnum = 'NO_FINDING' | 'VERY_LOW' | 'LOW' | 'MEDIUM' | 'HIGH';
    export const DamageExtentEnum = {
        NoFinding: 'NO_FINDING' as DamageExtentEnum,
        VeryLow: 'VERY_LOW' as DamageExtentEnum,
        Low: 'LOW' as DamageExtentEnum,
        Medium: 'MEDIUM' as DamageExtentEnum,
        High: 'HIGH' as DamageExtentEnum
    };
    export type RepairTaskStatusEnum = 'DRAFT' | 'TODO' | 'IN_PROGRESS' | 'FINISHED' | 'DECLINED';
    export const RepairTaskStatusEnum = {
        Draft: 'DRAFT' as RepairTaskStatusEnum,
        Todo: 'TODO' as RepairTaskStatusEnum,
        InProgress: 'IN_PROGRESS' as RepairTaskStatusEnum,
        Finished: 'FINISHED' as RepairTaskStatusEnum,
        Declined: 'DECLINED' as RepairTaskStatusEnum
    };
}


